<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/Yarn4.mp4'

export default {
    name: 'yarnboard4',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/rob-otoole"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
